let config = {
  back: {
    url: 'https://devback.pikontrol.infometrika.com',
    toolbarMsg: '',
    dialog: false,
    color: 'secondary',
    message: ''
  },
  appName: 'iKontrol',
  logo: 'https://files.infometrika.com/Images/ik.svg'
}

export default config
